import config from 'config/appConfig';
import { useCallback } from 'react';

/**
 *　API連携カスタムフック
 */
export const useApiState = () => {
  // const navigate = useNavigate();

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * POST送信
   */
  const _post = async (path: string, requestBody: any): Promise<any> => {
    try {
      const response = await fetch(`${config.apiGateway.endpoint}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // const data = await response.body.json();

      return data;

      // return await post({"admin-api", path, myInit});
    } catch (e) {
      console.log('API通信エラー', e);
      throw e;
    }
  };

  return {
    // クイズ回答API
    postQuizAnswer: useCallback(
      async (request: {
        quizId: number;
        quizTitle: string;
        answers: {
          no: number;
          title: string;
          answerOptionNo: number;
          answerOptionTitle: string;
          correctOptionNo: number;
          correctOptionTitle: string;
          reportMailDescriptionHtml: string;
        }[];
        respondentInfo: {
          mailAddress: string;
          name: string;
          gender: string;
          birthDate: string;
          phoneNumber: string;
          residence: string;
          customField01: string;
          customField02: string;
          customField03: string;
        };
        isPreview: boolean;
      }): Promise<{
        quizHistoryCd: string;
      }> => {
        return await _post('/quiz_answer', request);
      },
      []
    ),
    // クイズ表示API
    postQuizDisplay: useCallback(async (request: { quizId: number }): Promise<void> => {
      return await _post('/quiz_display', request);
    }, []),
    // クイズ履歴表示API
    postQuizHistory: useCallback(
      async (request: {
        quizCd: string;
        quizHistoryCd: string;
      }): Promise<{
        title: string;
        resultTitle: string;
        descriptionHtml: string;
        imageKey?: string;
        correctCount: number;
        answeredCount: number;
        copyright: string;
        quizTemplateId: number;
        lineFlag: boolean;
        lineCd: string;
      }> => {
        return await _post('/quiz_history', request);
      },
      []
    ),
    // クイズ参加API
    postQuizParticipate: useCallback(async (request: { quizId: number }): Promise<void> => {
      return await _post('/quiz_participate', request);
    }, []),
    // 診断回答API
    postDiagnosisAnswer: useCallback(
      async (request: {
        diagnosisId: number;
        diagnosisTitle: string;
        answers: {
          no: number;
          title: string;
          answerOptionNo: number;
          answerOptionTitle: string;
        }[];
        respondentInfo: {
          mailAddress: string;
          name: string;
          gender: string;
          birthDate: string;
          phoneNumber: string;
          residence: string;
          customField01: string;
          customField02: string;
          customField03: string;
        };
        isPreview: boolean;
      }): Promise<{
        diagnosisHistoryCd: string;
      }> => {
        return await _post('/diagnosis_answer', request);
      },
      []
    ),
    // 診断表示API
    postDiagnosisDisplay: useCallback(async (request: { diagnosisId: number }): Promise<void> => {
      return await _post('/diagnosis_display', request);
    }, []),
    // 診断履歴表示API
    postDiagnosisHistory: useCallback(
      async (request: {
        diagnosisCd: string;
        diagnosisHistoryCd: string;
      }): Promise<{
        title: string;
        resultTitle: string;
        descriptionHtml: string;
        imageKey?: string;
        copyright: string;
        diagnosisTemplateId: number;
        lineFlag: boolean;
        lineCd: string;
      }> => {
        return await _post('/diagnosis_history', request);
      },
      []
    ),
    // 診断参加API
    postDiagnosisParticipate: useCallback(
      async (request: { diagnosisId: number }): Promise<void> => {
        return await _post('/diagnosis_participate', request);
      },
      []
    ),
  } as const;
};
